module.exports = __webpack_public_path__ + "b0c58cacdca72b1d09df3a8a39d27dff.png";